(function () {
  // =========================
  // RESULT CONTENT (A/B/C)
  // =========================
  const RESULT_MAP = {
  A: {
    code: "A",
    title: "Hopeless Romantic",
    paragraphsSelf: [
      "Duygularla hareket ediyorsun ama dağınık değil.",
      "Senin için bir parça, yalnızca güzel olmakla kalmıyor; bir anlam taşıması gerekiyor.",
      "Yumuşaklık, küçük detaylar senin dilin."
    ],
    paragraphsSomeone: [
      "O, duygularıyla yaşayan biri.",
      "Küçük jestleri, anlamlı detayları fark eder.",
      "Bir hediye, onun için yalnızca materyal bir şey değil; bir his."
    ],
    ctaText: "Önerilerimizi Keşfet",
    url: "https://www.hofsilk.com/collections/hopeless-romantic",
    image: "https://cdn.shopify.com/s/files/1/0627/7955/6010/files/Hopeless_Romantic.jpg?v=1769693893"
  },
  B: {
    code: "B",
    title: "Sensual Lover",
    paragraphsSelf: [
      "Duyularla kurulan ilişki senin için her şeyin önünde.",
      "Rahatlık ve çekim aynı anda var olabilir diyorsun.",
      "Seçtiklerin sessiz ama etkisi uzun süre kalan türden."
    ],
    paragraphsSomeone: [
      "O, duyularıyla dünyayı algılar.",
      "Empatlık, rahatlık ve çekim onun için birbirinden ayrı değildir.",
      "Seçtiğin parça, teninde kalıcı bir iz gibi yer eder."
    ],
    ctaText: "Önerilerimizi Keşfet",
    url: "https://www.hofsilk.com/collections/sensual-lover",
    image: "https://cdn.shopify.com/s/files/1/0627/7955/6010/files/Sensual_Lover.jpg?v=1769693893"
  },
  C: {
    code: "C",
    title: "Magnetic Muse",
    paragraphsSelf: [
      "Sezgilerinle hareket ediyorsun.",
      "Ne zaman neyin sana iyi geleceğini biliyorsun.",
      "Bu hediye, kendinle kurduğun bu sessiz uyuma eşlik ediyor."
    ],
    paragraphsSomeone: [
      "O, dikkat çekmek için çaba harcamaz.",
      "Doğru şeyler kendiliğinden onun etrafında toplanır.",
      "Seçtiğin hediye, bu doğal dengeye eşlik eder."
    ],
    ctaText: "Önerilerimizi Keşfet",
    url: "https://www.hofsilk.com/collections/magnetic-muse",
    image: "https://cdn.shopify.com/s/files/1/0627/7955/6010/files/Magnetic_Muse.jpg?v=1769693892"
  }
};


  // =========================
  // QUIZ SETS 
  // =========================
  const QUIZ_SELF = [
    { t: "1- Bir hediyeyi senin için özel kılan nedir?", a:"Taşıdığı anlam", b:"Uyandırdığı his", c:"Bıraktığı etki" },
    { t: "2- Seni en iyi hangisi tanımlar?", a:"Romantik", b:"Sezgisel", c:"Ekstra" },
    { t: "3- Bir hediye sende hangi duyguyu uyandırsın istersin?", a:"Güven", b:"Heyecan", c:"Bilinmezlik" },
    { t: "4- Stil olarak hangisine daha yakınsın?", a:"Klasik", b:"Minimalizm", c:"Maksimalizm" },
    { t: "5- Aşk sence?", a:"Kırılgan ama gerçek", b:"Derin ve sezgisel", c:"Cesur ve özgüvenli" },
    { t: "6- Seni en çok ne etkiler?", a:"İnce düşünülmüş detaylar", b:"Sürprizler", c:"Özgüvenli hareketler" },
    { t: "7- Bir hediye seçerken hangi duygunun peşinde olursun?", a:"Huzurun", b:"Arzunun", c:"Gücün" },
    { t: "8- Aşkta kırmızı çizgin?", a:"Sınırlarım", b:"Özgürlüğüm", c:"Zevklerim" },
    { t: "9- Kendini en “kendin” hissettiğin an?", a:"Duygularımın sakin olduğu anlar", b:"Hislerime odaklandığım anlar", c:"Kontrolün bende olduğu anlar" },
    { t: "10- 2026’da aşkı nasıl yaşamak istersin?", a:"Daha duygusal", b:"Daha derin", c:"Daha spontane" }
  ];

  const QUIZ_SOMEONE = [
    { t: "1- Onu düşündüğünde hissettiğin ilk şey?", a:"Yumuşak bir sıcaklık", b:"Sessiz bir çekim", c:"Güçlü bir etki" },
    { t: "2- Sevgini nasıl anlatırsın?", a:"İnce jestlerle", b:"Dokunuşlarla", c:"Hayranlıkla" },
    { t: "3- Onunla aranızdaki bağ daha çok…", a:"Duygusal / Derin", b:"Tensel / Tutkulu", c:"Belirsiz / Toksik" },
    { t: "4- Onun stilini nasıl tanımlarsın?", a:"Zamansız ve feminen", b:"Sade ve rahat", c:"Net ve iddialı" },
    { t: "5- O ilk görüşte", a:"Samimi bağ kurar", b:"Sessizce gözlemler", c:"İz bırakır" },
    { t: "6- Onu mutlu eden şey daha çok…", a:"Düşünülmüş detaylar", b:"Yaşanan anlar", c:"Beklenmedik sürprizler" },
    { t: "7- Onun için çekicilik…", a:"Romantiktir", b:"Tenseldir", c:"Karizmatiktir" },
    { t: "8- Bu hediyeyi aldığında ne hissetsin istersin?", a:"Değerli", b:"Mutlu", c:"Seksi" },
    { t: "9- Bu hediyeyi ona nasıl vereceksin?", a:"Uzun bir akşam yemeğinden sonra, evde.", b:"Onunla çıktığımız tatilde.", c:"Spontane bir şekilde." },
    { t: "10- Onun sevgi dili sence?", a:"Sözler", b:"Dokunuş", c:"Hareketler" }
  ];

  // =========================
  // DOM
  // =========================
  const $questions = document.getElementById("quiz-questions");
  const $calc = document.getElementById("quiz-calc");
  const $reset = document.getElementById("quiz-reset");
  const $hint = document.getElementById("quiz-hint");

  const $result = document.getElementById("quiz-result");
  const $title = document.getElementById("result-title");
  const $text = document.getElementById("result-text");
  const $cta = document.getElementById("result-cta");
  const $media = document.getElementById("result-media");
  const $img = document.getElementById("result-image");

  let activeQuiz = null; // array of 10 questions

  // =========================
  // Helpers
  // =========================
  function escapeHtml(str) {
    return String(str)
      .replaceAll("&","&amp;")
      .replaceAll("<","&lt;")
      .replaceAll(">","&gt;")
      .replaceAll('"',"&quot;")
      .replaceAll("'","&#039;");
  }

  function renderQuiz(quizArr) {
    activeQuiz = quizArr;

    $questions.innerHTML = quizArr.map((q, idx) => {
      const qi = idx + 1;
      const name = `q${qi}`;

      return `
        <div class="q" data-q="${qi}">
          <p class="q-title">${escapeHtml(q.t)}</p>

          <div class="opts">
            <div class="opt">
              <input type="radio" id="${name}_A" name="${name}" value="A">
              <label for="${name}_A">A) ${escapeHtml(q.a)}</label>
            </div>

            <div class="opt">
              <input type="radio" id="${name}_B" name="${name}" value="B">
              <label for="${name}_B">B) ${escapeHtml(q.b)}</label>
            </div>

            <div class="opt">
              <input type="radio" id="${name}_C" name="${name}" value="C">
              <label for="${name}_C">C) ${escapeHtml(q.c)}</label>
            </div>
          </div>
        </div>
      `;
    }).join("");

    $calc.disabled = false;
    $hint.style.display = "none";
    hideResult();
  }

  function hideResult() {
    $result.style.display = "none";
    $title.textContent = "";
    $text.innerHTML = "";
    $cta.href = "#";
    $cta.textContent = "Gifts";
    $media.style.display = "none";
    $img.removeAttribute("src");
    $img.setAttribute("alt", "");
  }

  function getAnswers() {
    if (!activeQuiz) return null;

    const answers = [];
    for (let i = 1; i <= activeQuiz.length; i++) {
      const checked = document.querySelector(`input[name="q${i}"]:checked`);
      if (!checked) return null;
      answers.push(checked.value); // "A" / "B" / "C"
    }
    return answers;
  }

  function pickWinnerByRatio(answers) {
    const counts = { A: 0, B: 0, C: 0 };
    answers.forEach(v => counts[v]++);

    
    const max = Math.max(counts.A, counts.B, counts.C);
    const tied = Object.keys(counts).filter(k => counts[k] === max);

    if (tied.length === 1) {
      return { winner: tied[0], counts };
    }

    
    for (let i = answers.length - 1; i >= 0; i--) {
      if (tied.includes(answers[i])) return { winner: answers[i], counts };
    }

    // fallback
    return { winner: tied[0], counts };
  }

  function renderResult(winnerKey, counts) {
    const data = RESULT_MAP[winnerKey];
    if (!data) return;

    const total = counts.A + counts.B + counts.C;
    const pA = Math.round((counts.A / total) * 100);
    const pB = Math.round((counts.B / total) * 100);
    const pC = Math.round((counts.C / total) * 100);

    $result.style.display = "block";
    $title.textContent = `${data.code} - ${data.title}`;

    // paragraphs
    const who = document.querySelector('input[name="who"]:checked')?.value;
    const paragraphs =
    who === "someone"
    ? (data.paragraphsSomeone || [])
    : (data.paragraphsSelf || []);

    $text.innerHTML = paragraphs.map(p => `<p>${escapeHtml(p)}</p>`).join("");


    // CTA
    $cta.href = data.url;
    $cta.textContent = data.ctaText;

    // image 
    if (data.image && data.image.trim() !== "") {
      $media.style.display = "block";
      $img.src = data.image;
      $img.alt = `${data.title}`;
    } else {
      $media.style.display = "none";
    }


    $result.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function resetAll() {
    // reset selector
    document.querySelectorAll('input[name="who"]').forEach(i => i.checked = false);

    // reset quiz
    activeQuiz = null;
    $questions.innerHTML = "";
    $calc.disabled = true;
    $hint.style.display = "none";
    hideResult();
  }

  // =========================
  // Events
  // =========================
  document.querySelectorAll('input[name="who"]').forEach(r => {
    r.addEventListener("change", function () {
      if (this.value === "self") renderQuiz(QUIZ_SELF);
      if (this.value === "someone") renderQuiz(QUIZ_SOMEONE);
    });
  });

  $calc.addEventListener("click", function () {
    $hint.style.display = "none";

    const answers = getAnswers();
    if (!answers) {
      $hint.style.display = "block";
      return;
    }

    const { winner, counts } = pickWinnerByRatio(answers);
    renderResult(winner, counts);
  });

  $reset.addEventListener("click", resetAll);

  // Init
  resetAll();
})();
/* =========================
   COOKIE PERSISTENCE (24h) — NO SCOPE DEPENDENCY
   ========================= */
(function () {
  const COOKIE_RESULT = "hof_quiz_result";
  const COOKIE_WHO = "hof_quiz_who";       
  const TTL_SECONDS = 60 * 60 * 24;         

  // --- Cookie helpers ---
  function setCookie(name, value, maxAgeSeconds) {
    const safeValue = encodeURIComponent(String(value));
    document.cookie = `${name}=${safeValue}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax`;
  }
  function getCookie(name) {
    const cookies = document.cookie ? document.cookie.split("; ") : [];
    for (const c of cookies) {
      const idx = c.indexOf("=");
      const k = idx > -1 ? c.slice(0, idx) : c;
      const v = idx > -1 ? c.slice(idx + 1) : "";
      if (k === name) return decodeURIComponent(v);
    }
    return null;
  }
  function deleteCookie(name) {
    document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
  }

  // --- Result content ---
const RESULT_MAP = {
  A: {
    code: "A",
    title: "Hopeless Romantic",
    paragraphsSelf: [
      "Duygularla hareket ediyorsun ama dağınık değil.",
      "Senin için bir parça, yalnızca güzel olmakla kalmıyor; bir anlam taşıması gerekiyor.",
      "Yumuşaklık,küçük detaylar senin dilin."
    ],
    paragraphsSomeone: [
      "O, duygularıyla yaşayan biri.",
      "Küçük jestleri, anlamlı detayları fark eder.",
      "Bir hediye, onun için yalnızca materyal bir şey değil; bir his."
    ],
    ctaText: "Önerilerimizi Keşfet",
    url: "https://www.hofsilk.com/collections/hopeless-romantic",
    image: "https://cdn.shopify.com/s/files/1/0627/7955/6010/files/Hopeless_Romantic.jpg?v=1769693893"
  },
  B: {
    code: "B",
    title: "Sensual Lover",
    paragraphsSelf: [
      "Duyularla kurulan ilişki senin için her şeyin önünde.",
      "Rahatlık ve çekim aynı anda var olabilir diyorsun.",
      "Seçtiklerin sessiz ama etkisi uzun süre kalan türden."
    ],
    paragraphsSomeone: [
      "O, duyularıyla dünyayı algılar.",
      "Empatlık, rahatlık ve çekim onun için birbirinden ayrı değildir.",
      "Seçtiğin parça, teninde kalıcı bir iz gibi yer eder."
    ],
    ctaText: "Önerilerimizi Keşfet",
    url: "https://www.hofsilk.com/collections/sensual-lover",
    image: "https://cdn.shopify.com/s/files/1/0627/7955/6010/files/Sensual_Lover.jpg?v=1769693893"
  },
  C: {
    code: "C",
    title: "Magnetic Muse",
    paragraphsSelf: [
      "Sezgilerinle hareket ediyorsun.",
      "Ne zaman neyin sana iyi geleceğini biliyorsun.",
      "Bu hediye, kendinle kurduğun bu sessiz uyuma eşlik ediyor."
    ],
    paragraphsSomeone: [
      "O, dikkat çekmek için çaba harcamaz.",
      "Doğru şeyler kendiliğinden onun etrafında toplanır.",
      "Seçtiğin hediye, bu doğal dengeye eşlik eder."
    ],
    ctaText: "Önerilerimizi Keşfet",
    url: "https://www.hofsilk.com/collections/magnetic-muse",
    image: "https://cdn.shopify.com/s/files/1/0627/7955/6010/files/Magnetic_Muse.jpg?v=1769693892"
  }
};


  function escapeHtml(str) {
    return String(str)
      .replaceAll("&","&amp;")
      .replaceAll("<","&lt;")
      .replaceAll(">","&gt;")
      .replaceAll('"',"&quot;")
      .replaceAll("'","&#039;");
  }

  function renderSavedResult(letter) {
    const data = RESULT_MAP[letter];
    if (!data) return;

    const $result = document.getElementById("quiz-result");
    const $title = document.getElementById("result-title");
    const $text = document.getElementById("result-text");
    const $cta = document.getElementById("result-cta");
    const $media = document.getElementById("result-media");
    const $img = document.getElementById("result-image");

    if (!$result || !$title || !$text || !$cta || !$media || !$img) return;

    $result.style.display = "block";
    $title.textContent = `${data.code} - ${data.title}`;
    const who = getCookie(COOKIE_WHO);
    const paragraphs =
    who === "someone"
    ? (data.paragraphsSomeone || [])
    : (data.paragraphsSelf || []);

$text.innerHTML = paragraphs.map(p => `<p>${escapeHtml(p)}</p>`).join("");

    $cta.href = data.url;
    $cta.textContent = data.ctaText;

    // image
    if (data.image) {
      $media.style.display = "block";
      $img.src = data.image;
      $img.alt = data.title;
    } else {
      $media.style.display = "none";
      $img.removeAttribute("src");
      $img.alt = "";
    }
  }

  function saveFromCurrentDOM() {
    
    const t = (document.getElementById("result-title")?.textContent || "").trim();
    const letter = (t[0] || "").toUpperCase();
    if (letter === "A" || letter === "B" || letter === "C") {
      setCookie(COOKIE_RESULT, letter, TTL_SECONDS);

      const who = document.querySelector('input[name="who"]:checked')?.value;
      if (who === "self" || who === "someone") setCookie(COOKIE_WHO, who, TTL_SECONDS);
    }
  }

  function restoreWhoIfAny() {
    const savedWho = getCookie(COOKIE_WHO);
    if (savedWho !== "self" && savedWho !== "someone") return;

    const el = document.querySelector(`input[name="who"][value="${savedWho}"]`);
    if (el) {
      el.checked = true;
      // Trigger your existing handler to render the correct 10-question set
      el.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // --- Hook ---
  const calcBtn = document.getElementById("quiz-calc");
  if (calcBtn) {
    calcBtn.addEventListener("click", function () {
      
      setTimeout(saveFromCurrentDOM, 50);
    });
  }

  // --- Hook ---
  const resetBtn = document.getElementById("quiz-reset");
  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      deleteCookie(COOKIE_RESULT);
      deleteCookie(COOKIE_WHO);
    });
  }

  // --- Auto-restore on load ---
  const saved = getCookie(COOKIE_RESULT);
  if (saved === "A" || saved === "B" || saved === "C") {
    restoreWhoIfAny();
    // Render
    renderSavedResult(saved);
  }
})();
